import React from 'react'
import ItemProducto from './ItemProducto'
import { Row } from 'react-bootstrap'
const ItemCliente = ({ data, executeScroll }) => {
    const { tipo, posicion, productos, descripcion } = data;
    const izquierda = posicion === 'izquierda' ? true : false;

    return (
        <section id={tipo.replace(' ', '-').toLowerCase()} className={`contenedor-ipc ${!izquierda ? 'c-ipc-inverso' : ''}`}>
            <div className={`item1 bg-${tipo.replace(' ', '-').toLowerCase()}`}>
                <div>
                    <h1>{tipo.replace(' ', '\n')}_</h1>
                    <p>
                        {
                            descripcion.split("\n").map((item, i) => {
                                return (
                                    <span key={i}>
                                        {item}
                                        <br />
                                    </span>
                                )
                            })
                        }
                    </p>
                </div>
            </div>
            <div className="item2">
                <Row className="justify-content-center mx-0">
                    {productos.map((producto, i) => <ItemProducto key={i} producto={producto} executeScroll={executeScroll} tipo={tipo} />)}
                </Row>
            </div>
        </section>
    )
}


export default ItemCliente

